import type {
  ISplineItemConfig,
  IWideAreaMeasurementConfigStrategy
} from '@/components/boxes/measurementBoxes/wideAreaMeasurement/interface.ts';
import {
  apSlSplineItemConfigCollection,
  config
} from '@/components/boxes/measurementBoxes/wideAreaMeasurement/WideAreaMeasurementConfigGetter.ts';
import { injectable } from 'inversify';
import { SceneItemKind } from '@/engine/app/interfaces.ts';

@injectable()
export class WideAreaMeasurementConfigStrategy implements IWideAreaMeasurementConfigStrategy {
  public getConfigByMeasurementSceneItemKind(kind: SceneItemKind): Array<ISplineItemConfig> | undefined {
    switch (kind) {
      case SceneItemKind.SplineAreaMeasurement: return config;
      case SceneItemKind.UnrestrictedSplineAreaMeasurement: return apSlSplineItemConfigCollection;
    }
  }
}
